import Waypoint from 'exports-loader?Waypoint!waypoints/lib/noframework.waypoints.js'

/**
 * An in-view component.
 * @author Dayne Coulson-Hoffacker
 */
export default class InView {
  /**
   * Constructs a new section.
   * @param {Object} options - Options.
   * @param {HTMLElement} options.element - Container.
   */
  constructor (options) {
    this.element = options.element
    this.homeHeroReveal = options.homeHeroReveal
    this.ourClientsReveal = options.ourClientsReveal
    this.contactReveal = options.contactReveal
    this.aboutLexonReveal = options.aboutLexonReveal
    this.offset = '80%'
    this.homeHeroCopy = document.querySelector('.hero-copy')
    this.homeHeroCopyP = document.querySelector('.hero-copy p')
    this.ourClients = document.querySelector('[data-component="our-clients"]')
    this.contact = document.querySelector('[data-component="contact"]')
    this.aboutLexon = document.querySelector('[data-component="about-us"]')

    // Waypoints
    var homeHeroWaypoint = new Waypoint({
      element: this.homeHeroCopyP,
      handler: () => {
        this.homeHeroCopy.classList.add('visible')
        this.homeHeroReveal()
        homeHeroWaypoint.destroy()
      },
      offset: this.offset
    })

    var ourClientsWaypoint = new Waypoint({
      element: this.ourClients,
      handler: () => {
        this.ourClients.classList.add('visible')
        this.ourClientsReveal()
        ourClientsWaypoint.destroy()
      },
      offset: this.offset
    })

    var contactWaypoint = new Waypoint({
      element: this.contact,
      handler: () => {
        this.contact.classList.add('visible')
        this.contactReveal()
        contactWaypoint.destroy()
      },
      offset: this.offset
    })

    var aboutLexonWaypoint = new Waypoint({
      element: this.aboutLexon,
      handler: () => {
        this.aboutLexon.classList.add('visible')
        this.aboutLexonReveal()
        aboutLexonWaypoint.destroy()
      },
      offset: this.offset
    })

  }
}



// WEBPACK FOOTER //
// ./components/in-view/index.js